var map = {
	"./errorBeep.mp3": "0a1i",
	"./successBeep.mp3": "olYR"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6OKB";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audios ^\.\/.*\.mp3$
// module id = 6OKB
// module chunks = 3